// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addSubCategoryStyle_invalidDataError__WlNzJ"};